<template>
    <div class="entity-type-input">
        <md-button class="!ml-0 !mr-1" :class="{'md-secondary': (value == 'company')}" @click="$emit('input', 'company')">
            {{ $t("registration.want-to-fly-pro") }}
        </md-button>
        <md-button :class="{'md-secondary': (value == 'individual')}" @click="$emit('input', 'individual')">
            {{ $t("registration.want-to-fly-private") }}
        </md-button>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            default: null,
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~webapp/styles/_variables';

.entity-type-input {
    display: flex;
    justify-content: start;
    align-items: center;
    .md-button {
        border-radius: 5px;
        text-transform: none;
        font-size: 14px;
        height: 30px;
        min-width: 120px;
        &.md-secondary {
            color: white;
            background-color: $primary-color-dark;
        }
        &:not(.md-secondary) {
            color: $primary-color-dark;
            border: solid 1px $primary-color-dark;
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/widgets/EntityTypeInput.vue